const userHasPermissions = (globalData, permissions) => {
  let userPermissions = globalData?.currentUser?.currentUserData?.userPermissionKeys
 
  return (
    permissions?.length > 0 && userPermissions?.length > 0 && permissions.every(elem => userPermissions.indexOf(elem) > -1)
  );
};

const userHasFunctionRole = (globalData, roleName) => {
  return (
    globalData?.currentUser?.currentUserData?.functionRole === roleName
  );
};

const userHasAtLeastOnePermission = (globalData,itemPermissions) => {
  if (!globalData.currentUser.isAuthorized){
    return false;
  }
  let user = globalData?.currentUser?.currentUserData
  if (user?.userPermissionKeys) {
    if (itemPermissions.length === 0) {
      return true;
    } else {
      return itemPermissions.some(
        (r) => user.userPermissionKeys.indexOf(r) >= 0
      );
    }
  }
  return false;
};

export {
  userHasPermissions,
  userHasFunctionRole,
  userHasAtLeastOnePermission
};
